// Utils
import {exists} from "../../utils/helpers.js";

const WEEKDAYS_IDX = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

const MONTH_IDX = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];

const getTimeParts = (hour, min) => {
  let hourFormatted = hour;
  let minuteFormatted = min;
  let meridian = "AM";

  if (hour > 12) {
    hourFormatted -= 12;
    meridian = "PM";
  } else if (hour === 12) {
    meridian = "PM";
  } else if (hour === 0) hourFormatted = 12;

  if (minuteFormatted < 10) minuteFormatted = `0${minuteFormatted}`;

  return {hour: `${hourFormatted}`, min: `${minuteFormatted}`, meridian};
};

const getSuffix = date => {
  if (date === 1 || date === 21 || date === 31) return "st";
  if (date === 2 || date === 22) return "nd";
  if (date === 3 || date === 23) return "rd";
  return "th";
};

/**
 * Facility Notifications list label for a group's send times (already in facility timezone).
 * @param {Array<object>} times
 * @param {string} freq Daily / Weekly / Monthly / Annual
 * @returns {string}
 */
const formatTime = (times, freq) => {
  let formatted = "";
  let prevDateStr = "";

  for (let i = 0; i < times.length; i++) {
    const time = times[i];
    const {hour, min, dayOfWeek, dayOfMonth, month, dateStr} = time;

    if (!prevDateStr || prevDateStr !== dateStr) {
      if (i !== 0 && freq !== "Daily") formatted = `${formatted}), `;
      else if (i !== 0) formatted = `${formatted}, `;

      if (month) formatted = `${formatted}${MONTH_IDX[month - 1]} ${dayOfMonth} (`;
      else if (dayOfMonth) {
        const formattedDayOfMonth = `the ${dayOfMonth}${getSuffix(dayOfMonth)}`;
        formatted = `${formatted}${formattedDayOfMonth} (`;
      } else if (exists(dayOfWeek)) formatted = `${formatted}${WEEKDAYS_IDX[dayOfWeek]} (`;
    } else if (i !== 0) formatted = `${formatted}, `;

    prevDateStr = dateStr;

    const {hour: formattedHour, min: formattedMin, meridian} = getTimeParts(hour, min);

    if (exists(hour)) formatted = `${formatted}${formattedHour}:${formattedMin} ${meridian}`;
  }

  if (freq !== "Daily") formatted = `${formatted})`;

  return formatted;
};

export default formatTime;
